import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { CommonService } from '../../../shared/providers/common.service';
import { NewsTickerDetailsModel } from '../../../shared/models/NewsTickerDetailsModel';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../../shared/providers/loader.service';
import { MultipleEmailIdModel } from '../../../shared/models/MultipleEmailIdModel';
import { IShareReportModel } from '../../../shared/models/IShareRportModel';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OfferService } from '../../../shared/providers/offer.service';
import { OpportunityOfferListOutputModel } from '../../../shared/models/OpportunityOfferListOutputModel';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { OpportunityOfferOutputModel } from '../../../shared/models/OpportunityOfferOutputModel';

export enum Timeline {
  BOV = 1,
  Premarketing = 2,
  Marketing = 3,
  DealMaking = 4,
  Closed = 5
}

export interface INotificationModel {
  CreatedById: number,
  PropertyId: number
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @Input() propertyGuid: string;
  @Input() propertyId: number = 0;
  @Input() property: any;
  @Input() offerstatusid: number;
  @Input() offerGuid: string;
  @Input() isFromPortfolio: boolean = false;
  @Output() loadProspectTab = new EventEmitter();
  @Output() showPlaceOffer = new EventEmitter();
  haveaccesstoviewlocation: boolean = true;
  isShareReport: boolean = false;
  timeline = Timeline;
  selectedTimelineId = this.timeline.Marketing;
  defaultSelectedTimelineId = 0;
  offerList: OpportunityOfferListOutputModel[];
  unChangedofferList: OpportunityOfferOutputModel[];
  offers: OpportunityOfferOutputModel[];
  AssociatedBrokers = [];
  IsArchive = 0;
  showMarketing = false as boolean;
  price = {} as any;
  BOVDate: Date;
  PreMarketingDate: Date;
  MarketingDate: Date;
  DealMakingDate: Date;
  ClosedDate: Date;
  isOpened = true;
  timeOffset = 0;
  showMarketData = false;
  isFav = false;
  emailValid: boolean = true;
  propertydata: any;
  emailvalidation: string = '';
  isAdmin: boolean;
  hideBroker = false;
  dtOptions = {};
  protected readonly BASE_URL: string = environment.base_url;
  mailIds: MultipleEmailIdModel[];
  keyCode: number[];
  isDisliked = false;
  propertyStatus: string;
  user: any;
  notificationModel: INotificationModel;
  prospectTabVisibility = false as boolean;
  capratetext: string = 'Cap Rate';
  constructor(private http: HttpClient, public _authenticationService: AuthenticationService, private commonService: CommonService,
    private propertyListing: PropertyListingService, public Validation: ValidationService,
    private _toastService: ToastService, private _changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute, private loader: LoaderService,
    private router: Router, private _propertyService: PropertyListingService, private _offerService: OfferService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.user = this._authenticationService.user as any;
    this.IsArchive = this.property != null && this.property.Archive != undefined ? this.property.Archive ? 1 : 0 : 0;
    if (this.property.ConfidentialLocation && !this._authenticationService.Admin() && !this._authenticationService.SuperAdmin() && !this.property.IsPortfolio && !this._authenticationService.Broker() && !this._authenticationService.DataEntryStaff()) {
      this.haveaccesstoviewlocation = false;
    }
    else {
      this.haveaccesstoviewlocation = true;
    }
    this.prospectTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
      || this._authenticationService.Admin()
      || this._authenticationService.SuperAdmin()
      || (this.property.ShowProspectToSeller && this.property.SellerId.includes(this.user.Id));

    if (this.offerstatusid == 0) {
      if (this.property != null && this.property.Id > 0) {
        this._propertyService.getPropertyDetails(this.property.Guid, this.user.Id, false, true).subscribe(res => {
          if (res != null && !res.IsAccessDenied && !res.IsPropertyExist) {
            this.propertydata = res
            this.offerstatusid = this.propertydata.OfferStatusId;
            this.offerGuid = this.propertydata.OfferGuid;
            this.selectedTimelineId = this.offerstatusid == 456 ? this.timeline.Closed : (
              [462, 460, 455].includes(this.offerstatusid) ? this.timeline.DealMaking : (
                this.property.PropertyStatusId == 349 ? this.timeline.BOV : (
                  this.property.PropertyStatusId == 350 ? this.timeline.Premarketing : (
                    this.timeline.Marketing
                  )
                )
              )
            )
            this.defaultSelectedTimelineId = this.selectedTimelineId;
          }
        });
      }
    }
    else {
      this.selectedTimelineId = this.offerstatusid == 456 ? this.timeline.Closed : (
        [462, 460, 455].includes(this.offerstatusid) ? this.timeline.DealMaking : (
          this.property.PropertyStatusId == 349 ? this.timeline.BOV : (
            this.property.PropertyStatusId == 350 ? this.timeline.Premarketing : (
              this.timeline.Marketing
            )
          )
        )
      )
    }

    this.showMarketing = this.property.SellerId.includes(this.user.Id);
    this.defaultSelectedTimelineId = this.selectedTimelineId;

    this.propertyListing.propertyhistoryfortimeline(this.property.Id).subscribe(response => {
      this.BOVDate = response.filter(i => i.StatusId == 349).map(p => p.Date)[0];
      this.PreMarketingDate = response.filter(i => i.StatusId == 350).map(p => p.Date)[0];
      this.MarketingDate = response.filter(i => i.StatusId == 351 || i.StatusId == 355 || i.StatusId == 356).map(p => p.Date)[0];
      this.DealMakingDate = response.filter(i => i.StatusId == 352).map(p => p.Date)[0];
      this.ClosedDate = response.filter(i => i.StatusId == 354).map(p => p.Date)[0];
    });

    if (this.property.TickerSymbol != null && this.property.TickerSymbol != "" && this.property.TickerSymbol != undefined) {
      this.loadNews();
    }

    this.keyCode = [32, 188, 13];
    ////this.getPropertyDetails();

    if (this.property.PropertyCharacteristicsList.filter(x => x.Id == 2908).length > 0 || this.property.OnlyZCF) {
      this.capratetext = 'ZCF';
    }
    else {
      this.capratetext = 'Cap Rate';
    }

    if (this._authenticationService.Principal1031() || this._authenticationService.Principal() || this._authenticationService.Seller()) {
      this.commonService.addNotificationToBeBrokers(this.user.Id, this.property.Id).subscribe(response => {
        var result = response;
      });
    }

    this.isAdmin = false;
    this.user = this._authenticationService.user;
  }


  getColorForStock(value: string) {
    if (value != null) {
      value = value.toString();
      if (value.includes('-')) {
        return '#f0605d'
      }
      else {
        return '#28A79B'
      }
    }
  }
  loadNews() {

    this.commonService.GetNewsTickerDetails(this.property.TickerSymbol, 6112).subscribe(response => {

      if (!response.IsLatestAvailable) {
        this.getSummaryDetails();

      }
      else {
        if (response != null) {
          this.stockInformation = JSON.parse(response.DataJson);
          let stockResponse = this.stockInformation != null && this.stockInformation != undefined ?
            this.stockInformation.quoteResponse.result[0] : null;
          if (stockResponse != null && stockResponse != undefined) {
            const regularMarketPrice = stockResponse["regularMarketPrice"];
            const regularMarketChangePercent = this.formatAsPercentage(stockResponse["regularMarketChangePercent"]);
            const regularMarketChange = stockResponse["regularMarketChange"];
            const regularMarketTime = stockResponse["regularMarketTime"];
            const symbol = stockResponse["symbol"];
            const quoteSourceName = stockResponse["quoteSourceName"];
            this.price = {
              regularMarketPrice,
              regularMarketChangePercent,
              regularMarketChange,
              regularMarketTime,
              symbol,
              quoteSourceName
            }
            this.showMarketData = true;
          }
        }
      }
    });
  }

  formatAsPercentage(rawValue: number): string {
    if (rawValue != null && rawValue != undefined) {
      return `${rawValue.toFixed(2)}%`;
    }
  }

  //loadSummaryDetails() {
  //  this.commonService.GetNewsTickerDetails(this.property.TickerSymbol, 6102).subscribe(response => {
  //    if (!response.IsLatestAvailable) {
  //      this.propertyListing.GetSummaryDetails(this.property.TickerSymbol).subscribe(response => {
  //        this.newsDetail.DataJson = JSON.stringify(response);
  //        this.newsDetail.Ticker = this.property.TickerSymbol;
  //        this.newsDetail.TypeId = 6102;
  //        this.showMarketData = true;
  //        this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
  //        });
  //      });
  //    }
  //  });
  //}

  newsDetail = {} as NewsTickerDetailsModel;
  stockInformation = {} as any;
  getSummaryDetails() {
    this.propertyListing.GetStockValues(this.property.TickerSymbol).subscribe(response => {
      if (response != null) {
        this.stockInformation = response;
        let stockResponse = this.stockInformation != null && this.stockInformation != undefined ?
          this.stockInformation.quoteResponse.result[0] : null;
        if (stockResponse != null && stockResponse != undefined) {
          const regularMarketPrice = stockResponse["regularMarketPrice"];
          const regularMarketChangePercent = this.formatAsPercentage(stockResponse["regularMarketChangePercent"]);
          const regularMarketChange = stockResponse["regularMarketChange"];
          const regularMarketTime = stockResponse["regularMarketTime"];
          const symbol = stockResponse["symbol"];
          const quoteSourceName = stockResponse["quoteSourceName"];
          this.price = {
            regularMarketPrice,
            regularMarketChangePercent,
            regularMarketChange,
            regularMarketTime,
            symbol,
            quoteSourceName
          }
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.property.TickerSymbol;
          this.newsDetail.TypeId = 6112;
          this.showMarketData = true;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
    });
  }

  setMenuID(id) {
    if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
      localStorage.removeItem('currentFileRefreshTab');
    }
    if (this.property.PropertyForId == 601 || (this.property.PropertyForId == 602 && (id != this.timeline.BOV && id != this.timeline.Premarketing))) {
      if (this.defaultSelectedTimelineId >= id) {
        this.selectedTimelineId = id;
      }
      else {
        this.selectedTimelineId = this.defaultSelectedTimelineId;
      }
    }
    else if ((this.property.PropertyForId == 602 && (id == this.timeline.BOV || id == this.timeline.Premarketing))) {
      this._toastService.addToast({
        title: '',
        msg: 'No data available currently in this status',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
  }

  checkDatePassed(status) {

    if (this.defaultSelectedTimelineId >= status) {
      return 'success';
    }
    else {
      return 'inactive';
    }
    //else if (status) {
    //    return 'inactive';
    //}
  }
  toggle() {
    this.isOpened = !this.isOpened;
  }

  generateDealReport() {
    var newDate = new Date();
    var offset = newDate.getTimezoneOffset() / 60;

    this.loader.display(true);
    const httpHeader = this.Validation.GetAuthHeader();
    let offerId = (this.offerGuid == '' || this.offerGuid == undefined) ? this.property.OfferGuid : this.offerGuid;
    this._offerService.GenerateDealReport(offerId, this.user.Id, offset).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadPDFFile('/upload/pdffile/' + filenameWithoutExtension, filenameWithExtension);
      this.loader.display(false);
    });
  }

  loadProspect(type: any) {
    this.loadProspectTab.emit(type);
  }

  offerStatusChange(data) {

    let a = data.filter(x => [462, 460, 455, 456].includes(x.StatusId));
    this.offerGuid = a != null && a.length > 0 ? a[0].OfferDetailGuid : '';
    this.selectedTimelineId = data.filter(x => x.StatusId == 456).length > 0 ? this.timeline.Closed :
      (data.filter(x => [462, 460, 455].includes(x.StatusId)).length > 0 ?
        this.timeline.DealMaking : (
          this.property.PropertyStatusId == 349 ? this.timeline.BOV : (
            this.property.PropertyStatusId == 350 ? this.timeline.Premarketing : (
              this.timeline.Marketing
            )
          )
        )
      )
    this.defaultSelectedTimelineId = this.selectedTimelineId;
    this._changeDetectorRef.detectChanges();
  }

  placeOffer(offerVisiblity) {
    this.showPlaceOffer.emit(offerVisiblity);
  }

  search = "";
  onViewProperty(Guid) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
      this.isFav = params['isFav'] != undefined ? true : false;
      this.isDisliked = params['isDisliked'] != undefined ? true : false;
    });
    if (this.isFav) {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Favorites&link=' + encodeURIComponent(this.router.url));
    }
    else if (this.isDisliked) {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Disliked&link=' + encodeURIComponent(this.router.url));
    }
    else if (!this.Validation.IsinValid(this.search)) {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Saved Search&link=' + encodeURIComponent(this.router.url));
    }
    else {
      this.router.navigateByUrl('viewproperty/' + Guid + '?prevroute=Property List&link=' + encodeURIComponent(this.router.url));
    }
  }
  getPropertyDetails() {
    this._propertyService.getPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
      this.propertyStatus = response.PropertyStatus;
      this.property = response;
      if (this.property.PropertyCharacteristicsList.filter(x => x.Id == 2908).length > 0 || this.property.OnlyZCF) {
        this.capratetext = 'ZCF';
      }
      else {
        this.capratetext = 'Cap Rate';
      }
    });
  }

  generateReport(Id) {
    this.loader.display(true);
    const httpHeader = this.Validation.GetAuthHeader();
    this._propertyService.generateReport(Id).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadPDFFile('/upload/pdffile/' + filenameWithoutExtension, filenameWithExtension);
      this.loader.display(false);
    });
  }

  inputModel = {} as IShareReportModel;
  ShareReport() {
    if (this.mailIds != undefined && this.mailIds.length > 0) {
      this.loader.display(true);
      this.inputModel.PropertyId = this.propertyId;
      this.inputModel.UserId = this.user.Id;
      this.inputModel.EmailForShare = this.mailIds.map(function (data) { return data.value });
      this._propertyService.shareReport(this.inputModel).subscribe(resp => {
        let filenameWithExtension: string = resp.toString();
        let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
        setTimeout(() => {
          this.Validation.deletePdfFile('/upload/deletepdffile/' + filenameWithoutExtension);
        }, 5000);

        this.modalRef.hide();
        this.mailIds = [];
        this.loader.display(false);
      });
    }
    else {
      this._toastService.addToast({
        title: '',
        msg: 'No Email Address added',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
  }

  validEmail$(control: any) {

    if (control.value != "") {
      let serchfind: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      serchfind = regexp.test(control.value);
      if (serchfind == false) {
        return {
          'validEmail$': true
        };
      }
    }

    return null;
  }

  public validators = [this.validEmail$];

  public errorMessages = {
    'validEmail$': 'Invalid Email Address'
  };

  modalRef: BsModalRef;
  openPropertyShareModal(template: TemplateRef<any>, classes: any) {
    this.isShareReport = true;
    this.previewModalRef = this.modalService.show(template, { class: classes });
  }

  previewModalRef: BsModalRef;
  openPreviewModal(template: TemplateRef<any>, classes: any) {
    this.isShareReport = false;
    this.previewModalRef = this.modalService.show(template, { class: classes });
  }

  onClose() {
    this.previewModalRef.hide();
  }
}
